export default "__VITE_ASSET__BMH06fca__"